import React from 'react';
import PropTypes from 'prop-types';

const AddIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14.001">
        <path d="M6 13V8H1a1 1 0 010-2h5V1a1 1 0 012 0v5h5a1 1 0 010 2H8v5a1 1 0 11-2 0z" fill={fill} />
    </svg>
);

AddIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

AddIcon.defaultProps = {
    width: '14',
    height: '14.001',
    fill: '#fff'
};

export default AddIcon;
